<template>

  <div class="p-3">
    <div
      class="row"
      style="width: 100%">
      <div class="col-9">
        <div
          v-if="lastInvoce && lastInvoce.status === 'pending'"
          class="alert alert-warning">
          Você tem uma fatura pendente. <a :href="lastInvoce.secure_url" target="_blank">Clique aqui</a> para visualizar. 
        </div>
        <div class="card mb-3">
          <div class="card-header">
            <strong>Plano atual</strong>
          </div>
          <div class="card-body">
            <table class="table">
              <tbody>
                <tr>
                  <th style="border: 0; width: 120px">Plano:</th>
                  <td style="border: 0">{{ billingResume.plan.name }}</td>
                </tr>
                <tr>
                  <th>Ciclo:</th>
                  <td>{{ cycle }}</td>
                </tr>
                <tr>
                  <th>Valor:</th>
                  <td>{{ $n(billingResume.plan.value, { style: 'currency', currency: 'BRL' }) }}</td>
                </tr>
              </tbody>
            </table>
            <router-link
              class="btn btn-outline-primary"
              :to="{ path: '/billing/steps/plans' }">
              Mudar plano
              </router-link>
          </div>
        </div>
        <div class="card">
          <div class="card-header">
            <strong>Faturamento</strong>
          </div>
          <div class="card-body">
            <div><strong>Método de pagamento</strong></div>
            <div v-if="defaultPayment">
              {{ defaultPayment }}
            </div>
            <router-link
              class="btn btn-outline-primary mt-3"
              :to="{ path: '/billing/payment' }">
              Forma de pagamento
              </router-link>
            <hr>

            <div><strong>Dados de faturamento</strong></div>
            <div>{{ billingResume.customer.name }}</div>
            <div>{{ billingResume.customer.email }}</div>
            <div>{{ billingCustomerAddress }}</div>
            <router-link
              class="btn btn-outline-primary mt-3"
              :to="{ path: '/billing/details' }">
              Editar
              </router-link>
          </div>
        </div>
      </div>
      <div class="col-3">
        <div class="card mb-3">
          <div class="card-header">
            <strong>Faturas</strong>
          </div>
          <div class="card-body">
            <div class="mb-1"><b>Status de acesso</b></div>
            <span
              style="font-size: 1em;"
              class="badge badge-success"
              :class="`badge-${status.style}`">{{ $t(status.text) }}</span>
            <div
              v-if="billingResume.subscription.expires_at"
              :class="{ 'text-danger': suspended }">
              <hr>
              <div v-if="!suspended"><strong>Próxima fatura (Vencimento)</strong></div>
              <div v-if="suspended"><strong>Fim do ciclo</strong></div>
              <div>{{ $d(new Date(billingResume.subscription.expires_at), 'short') }}</div>
            </div>
            <div v-if="lastInvoce">
              <hr>
              <div><strong>Última fatura: <a :href="lastInvoce.secure_url" target="_blank">#{{ lastInvoceCode }}</a></strong></div>
              <div>{{ $t('Status:') }} <InvoiceStatus :value="lastInvoce.status" /></div>
              <div>{{ $d(new Date(lastInvoce.due_date), 'short') }}<br>{{ lastInvoce.price }}</div>
              <router-link
                class="btn btn-outline-primary mt-3"
                :to="{ path: '/billing/invoices' }">
                Histórico de faturas
                </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
import InvoiceStatus from '@/components/Parts/InvoiceStatus'

export default {
  name: 'BillingResume',
  components: {
    InvoiceStatus
  },
  data () {
    return {
    }
  },
  computed: {
    billingResume () {
      return this.$store.getters.getBillingResume
    },
    status () {
      return this.billingResume.subscription.active ? {
        text: 'Active',
        style: 'success'
      } : {
        text: 'Inactive',
        style: 'danger'
      }
    },
    cycle () {
      const options = { annually: 'Anual', monthly: 'Mensal' }
      return options[this.billingResume.plan.cycle_type]
    },
    billingCustomerAddress () {
      return [
        this.billingResume.customer.address,
        this.billingResume.customer.address_number,
        this.billingResume.customer.address_complement,
        this.billingResume.customer.city,
        this.billingResume.customer.region,
        this.billingResume.customer.neighborhood,
        this.billingResume.customer.country,
        this.billingResume.customer.zipcode
      ].filter(v => v).join(', ')
    },
    defaultPayment () {
      if (this.billingResume.default_paymethod) {
        // const displayNumber = this.billingResume.default_paymethod.display_number
        const lastDdigits = this.billingResume.default_paymethod.last_digits
        const year = this.billingResume.default_paymethod.year
        const month = this.billingResume.default_paymethod.month
        const date = this.$d(new Date(`${year}-${month}-01`), 'monthYearNum')
        return `**** ${lastDdigits} (${date})`
      }
      return null
    },
    lastInvoce () {
      if (this.billingResume && this.billingResume.subscription && this.billingResume.subscription.recent_invoices) {
        return this.billingResume.subscription.recent_invoices[0]
      }
      return null
    },
    lastInvoceCode () {
      if (this.lastInvoce) {
        return this.lastInvoce.iugu_invoice_id.slice(0, 7) + '...'
      }
      return null
    },
    suspended () {
      return this.billingResume.subscription.suspended
    }
  },
  created () {
  },
  methods: {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Billing/BillingResume.vue